export type TApp = 'app' | 'casino' | 'cc' | 'sports' | 'office';
export enum APP {
  APP = 'app',
  CASINO = 'casino',
  SPORTS = 'sports',
  LANDING = 'landing',
  ACCOUNT = 'account',
  WALLET = 'wallet',
}
export enum AUTH_STATE {
  HAS_REFRESH_TOKEN = 'has_refresh_token',
  HAS_VALID_TOKEN = 'has_valid_token',
  NO_TOKEN = 'no_token',
}
export enum ERROR_CODE {
  USER_EMAIL_REGISTERED = 'USER_EMAIL_REGISTERED',
  USER_EMAIL_NO_CORRECT = 'USER_EMAIL_NO_CORRECT',
  USER_NOT_EXIST = 'USER_NOT_EXIST',
  PHONE_NOT_REGISTERED = 'PHONE_NOT_REGISTERED',
  USER_BLOCKED = 'USER_BLOCKED',
  EMAIL_SENDER_ERROR = 'EMAIL_SENDER_ERROR',
  EMAIL_CODE_INCORRECT = 'EMAIL_CODE_INCORRECT',
}
export enum LANGS_ENUM {
  PT = 'pt',
  EN = 'en',
  ES = 'es',
}
export enum REFERRAL_STATE {
  SIGNUP,
  DEPOSIT,
}
export enum AFFILIATE_STATE {
  PENDING,
  ACTIVE,
  BLOCKED,
}
export enum AFFILIATE_MODE {
  FIRST_DEPOSIT = 'FIRST_DEPOSIT',
  ANUAL_DEPOSIT = 'ANUAL_DEPOSIT',
}
export enum ENUM_USER_LEVEL {
  CLIENT,
  AFFILATE,
}

export enum USER_RESULTS {
  LDB,
  RIO,
}
export enum EMAILS_CAMPAIGN_STATE {
  ACTIVE = 'ACTIVED',
  PAUSED = 'PAUSED',
  DELETED = 'DELETED',
}
export enum ENUM_USER_DATA_STATE {
  REGISTERED,
  DATA_COMPLETED,
  DATA_DOCS_COMPLETED,
}
export enum ENUM_USER_STATE {
  BLOCK,
  TEMPORARY,
  ACTIVE,
}
export enum ENUM_EMPLOYEE_GROUP {
  ADMINISTRATOR,
  CONSULTANT,
  VIEWER,
}
export enum ENUM_EMPLOYEE_STATE {
  BLOCK,
  ACTIVE,
}
export enum WITHDRAW_STATE {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
  SENDING = 'SENDING',
}

export enum AFFILIATE_COMMISION_STATE {
  PENDING,
  APPLIED,
}
export enum DEPOSIT_PROVIDER_CODE {
  PIX = 'IX',
  BOLETO = 'BL',
  CREDIT_CARD = 'CC',
  ASTROPAY = 'AP',
  BITCOIN = 'BT',
  MERCADOPAGO = 'MP',
}
export enum ENUM_DEPOSITS_PROVIDERS {
  WALLET = 'wallet',
  WALLET_EXCHANGE = 'wallet exchange',
  ASTROPAY = 'astropay',
  CAIXA = 'caixa',
  HOUSE = 'house',
  BRADESCO = 'bradesco',
  GN = 'gn',
  PS = 'ps',
  MERCADOPAGO = 'mercadopago',
  CELCOIN = 'celcoin',
}
export enum ENUM_ASTROPAY_STATUS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
}
export enum ENUM_CAIXA_STATUS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
}
export enum DEPOSIT_TRANSACTION_STATUS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
}
export enum GN_PIX_STATUS {
  ATIVA = 'ATIVA',
  CONCLUIDA = 'CONCLUIDA',
}
export enum GN_STATUS {
  APPROVED = 'approved',
  PAID = 'paid',
  SETTLED = 'settled',
  WAITING = 'waiting',
  NEW = 'new',
  UNPAID = 'unpaid',
  CANCELLED = 'cancelled',
  CANCELED = 'canceled',
  EXPIRED = 'expired',
  REFUNDED = 'refunded',
}
export enum MP_STATUS {
  APPROVED = 'approved',
  REJECTED = 'rejected',
}
export enum ODD_TYPE {
  SIMPLE = 'SIMPLE',
  FENCED = 'FENCED',
  FENCED_EXTENDED = 'FENCED_EXTENDED',
  DUKE = 'DUKE',
  TERNARY = 'TERNARY',
  PASS_FORWARD = 'PASS_FORWARD',
  PASS_BACKWARD = 'PASS_BACKWARD',
}
export enum BET_TYPE_DENOMINATION {
  GJ,
  DJ,
  CJ,
  MJ,
  DG,
  DD,
  TG,
  TD,
  PG,
  MI,
  CI,
  DDC,
  TDC,
}
export enum BET_TYPE_DENOMINATION_DESCRIPTION {
  GJ = 'GJ',
  DJ = 'DJ',
  CJ = 'CJ',
  MJ = 'MJ',
  DG = 'DG',
  DD = 'DD',
  TG = 'TG',
  TD = 'TD',
  PG = 'PG',
  MI = 'MI',
  CI = 'CI',
  DDC = 'DDC',
  TDC = 'TDC',
}
export enum ODDS_EVALUATION_TYPE {
  BASE = 'base',
  MEDIUM = 'medium',
  HIGH = 'high',
}
export enum EVENT_TYPE {
  AUTH = 'auth',
  SUBSCRIPTION = 'subscription',
  SUBSCRIBE = 'subscribe',
  UNSUBSCRIBE = 'unsubscribe',
  ALIVE = 'alive',
  DEVICE = 'device',
  REGISTER_USER_ACTION = 'register_user_action',
  REGISTER_USER_URL = 'register_user_url',
  CONN_ID = 'CONN_ID',
}
export enum EVENT_ALIVE {
  PING = 'ping',
  PONG = 'pong',
}
export enum EVENT_AUTH {
  AUTHORIZED = 'authorized',
  UNAUTHORIZED = 'unauthorized',
  AUTHORIZED_ADMIN = 'authorized admin',
  AUTHORIZED_CONSULTANT = 'authorized consultant',
}
export enum PUSHER_SUBSCRIPTIONS {
  WITHDRAW_CANCELLED = 'WITHDRAW_CANCELLED',
  WITHDRAW_APPROVED = 'WITHDRAW_APPROVED',
  WITHDRAW_PENDING = 'WITHDRAW_PENDING',
  WITHDRAW_PROCESING = 'WITHDRAW_PROCESING',
  NEW_BET = 'NEW_BET',
  REMOVE_BET = 'REMOVE_BET',
  WINNER_BET = 'WINNER_BET',
  DRAW_EVALUATED = 'DRAW_EVALUATED',
  DEPOSIT_CRYPTO_RECEIVED = 'DEPOSIT_CRYPTO_RECEIVED',
  DEPOSIT_APPROVED = 'DEPOSIT_APPROVED',
  DEPOSIT_PENDING = 'DEPOSIT_PENDING',
  DEPOSIT_CANCELLED = 'DEPOSIT_CANCELLED',
  AFFILIATE_VISITOR = 'AFFILIATE_VISITOR',
  UPDATE_USER_BALANCE = 'UPDATE_USER_BALANCE',
  USER_CHANGE_DATA = 'USER_CHANGE_DATA',
  USER_CHANGE_TICKET = 'USER_CHANGE_TICKET',
  USER_CONNECTED = 'USER_CONNECTED',
  USER_DISCONNECTED = 'USER_DISCONNECTED',
  USER_SIGNUP = 'USER_SIGNUP',
  USER_UPLOAD_DOCUMENT = 'USER_UPLOAD_DOCUMENT',
  USER_BLOCKED = 'USER_BLOCKED',
  CHAT_MESSAGE = 'CHAT_MESSAGE',
  PERSONAL_NOTIFICATION = 'PERSONAL_NOTIFICATION',
  PLATFORM_NOTIFICATION = 'PLATFORM_NOTIFICATION',
  GAME_ACTIVITY = 'GAME_ACTIVITY',
  CONNECTED_USERS = 'CONNECTED_USERS',
  ETH_BLOCK = 'ETH_BLOCK',
  GAME_CLOSE_BY_PROVIDER = 'GAME_CLOSE_BY_PROVIDER',
  TELEGRAM_MESSAGE = 'TELEGRAM_MESSAGE',
  TELEGRAM_MESSAGE_READED = 'TELEGRAM_MESSAGE_READED',
  TELEGRAM_USER_CONNECTED_CHANGE = 'TELEGRAM_USER_CONNECTED_CHANGE',
  SOME_USER_BANNED_CHAT = 'SOME_USER_BANNED_CHAT',
}

export enum BET_ERRORS {
  OK = 'OK',
  BAD_ODD = 'BAD ODD',
  BAD_DENOM = 'BAD DENOM',
  BAD_SOME_NUMBER_ARE_SAME = 'BAD SOME NUMBER ARE SAME',
  BAD_NUMBERS = 'BAD NUMBERS',
  BAD_SOME_GROUP_ARE_SAME = 'BAD SOME GROUP ARE SAME',
  BAD_AMOUNT = 'BAD AMOUNT',
  USER_BALANCE_INSUFICIENT = 'USER BALANCE INSUFICIENT',
  DRAW_TIME_EXPIRE = 'DRAW TIME EXPIRE',
  ERROR_INSERTING_BET = 'ERROR INSERTING BET',
  BAD_DRAW_ID = 'BAD DRAW ID',
  USER_BLOCKED = 'USER BLOCKED',
  RISK_WARNING = 'RISK WARNING',
  RISK_ACUMULATED_WARNING = 'RISK ACUMULATED WARNING',
  BAD_REFUND = 'BAD_REFUND',
  USER_SCHEDULE_FORBIDDEN = 'USER_SCHEDULE_FORBIDDEN',
}

export enum ENUM_USER_BLOCK {
  SELF,
  COMPANY,
  ORIGEN_NOT_ALLOWED,
}
export enum USER_REGISTRATION_ERRORS {
  USER_EMAIL_REGISTERED,
  USER_EMAIL_NO_CORRECT,
  USER_NOT_EXIST,
  PHONE_NOT_REGISTERED,
}
export enum USER_SIGN_ERRORS {
  USER_BLOCKED = 'USER_BLOCKED',
  USER_EMAIL_REGISTERED = 'USER_EMAIL_REGISTERED',
  CODE_NOT_CORRECT = 'CODE_NOT_CORRECT',
  NO_ERROR = '',
  NO_USER_FOUND = 'NO_USER_FOUND',
}
export enum API_ERRORS {
  ERROR_RESPONSE = 'ERROR_RESPONSE',
}
export enum DOCUMENTS_TYPE {
  UNDEFINED = 'Undefined',
  PROFILE_IMAGE = 'Profile image',
  PROOF_ADDRESS = 'Proof address',
  PASSPORT = 'Passport',
  TAX_ID = 'Tax id',
  NATIONAL_ID = 'National id',
}
export enum JWT_STRATEGY {
  CLIENT = 'jwt',
  EMPLOYEE = 'jwt-office',
  API = 'jwt-api',
  OPEN = 'open',
  SITE = 'site',
  OPERATOR = 'operator',
  PAYMENT = 'payment',
  REFRESH = 'refresh',
}
export enum WITHDRAW_CANCEL_REASON {
  BALANCE_INSUFICIENT = 'BALANCE_INSUFICIENT',
  BONUS_NOT_FULFILLED = 'BONUS_NOT_FULFILLED',
  CANCEL_BY_CLIENT = 'CANCEL_BY_CLIENT',
  PIX_KEY_NOT_WORK = 'PIX_KEY_NOT_WORK',
  DUPLICATED = 'DUPLICATED',
  EFI_ERROR = 'EFI_ERROR',
  EXTORNO = 'EXTORNO',
}
export enum WITHDRAW_WARNING {
  CREDIT_CARD_DEPOSIT = 'CREDIT_CARD_DEPOSIT',
}
export enum AFFILIATE_FORM_STATE {
  UNREADED = 'UNREADED',
  PENDING = 'PENDING',
  CLOSED = 'CLOSED',
  BLOCKED = 'BLOCKED',
}
export enum JOB_STATE {
  ACTIVED = 'ACTIVED',
  PAUSED = 'PAUSED',
}
export enum DOC_METADATA_STATE {
  PENDING,
  READED,
}
export enum PENDING_ACTION_STATE {
  PENDING,
  APPLIED,
  CANCELLED,
}
export enum ROOLBACK_STATE {
  PENDING = 'PENDING',
  APPLIED = 'PENDING',
}

export enum SCHEDULE_ZONES {
  AMERIA_SUL = 'America/Sao_Paulo',
  EUROPE = 'Europe/Berlin',
  ASIA = 'Asia/Hong_Kong',
}
